import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Developer",
          "Freelancer",
          "MERN Stack Developer",
          "Open Source Contributor",
          "Future enginner ",
           "Explorer",
           "Problem solver "
          
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 55,
        
      }}
    />
  );
}

export default Type;
